// Admin Dashboard → Marketing → Tagged links (?src=…): one row per source
// code. Visits, new visitors and guide views come from events carrying that
// src; "New accounts" are sign-ups whose first ever visit came from it
// (signup.first_src). Added for the ads (4.10.55): what those accounts went
// on to do — guides they made (a new guide or a copy, from guide_write
// events) and how many of them made at least one. Pure, for Jest.

const MADE = new Set(["new", "copy"]);

export function buildTaggedRows(events) {
  const rows = new Map();
  const row = (src) => {
    if (!rows.has(src)) rows.set(src, { src, visits: 0, newVisitors: 0, views: 0, signups: 0, guidesMade: 0, makers: 0 });
    return rows.get(src);
  };
  const srcOfAccount = new Map(); // uid → first_src of its sign-up
  (events || []).forEach((e) => {
    if (e.type === "visit" && e.src) {
      row(e.src).visits++;
      if (e.new === true) row(e.src).newVisitors++;
    } else if (e.type === "guide_view" && e.src) row(e.src).views++;
    else if (e.type === "signup" && e.first_src) {
      row(e.first_src).signups++;
      if (e.uid) srcOfAccount.set(e.uid, e.first_src);
    }
  });
  const makers = new Map(); // src → Set of uids that made a guide
  (events || []).forEach((e) => {
    if (e.type !== "guide_write" || !MADE.has(e.action)) return;
    const src = srcOfAccount.get(e.uid);
    if (!src) return;
    row(src).guidesMade++;
    if (!makers.has(src)) makers.set(src, new Set());
    makers.get(src).add(e.uid);
  });
  makers.forEach((uids, src) => (row(src).makers = uids.size));
  return [...rows.values()].sort((a, b) => b.visits - a.visits || b.views - a.views || a.src.localeCompare(b.src));
}
